import { render, staticRenderFns } from "./PortalTextarea.vue?vue&type=template&id=420ab0ae&scoped=true&"
import script from "./PortalTextarea.vue?vue&type=script&lang=ts&"
export * from "./PortalTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./PortalTextarea.vue?vue&type=style&index=0&id=420ab0ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ab0ae",
  null
  
)

export default component.exports